<div class="teams-list">
  <div class="team" *ngFor="let team of teams$ | async">
    <mat-checkbox
      color="primary"
      [disabled]="isSelectionDisable"
      (change)="onTeamSelect(team)"
      [checked]="teamSelection.isSelected(team)"
      (click)="$event.stopPropagation()">

      {{ team.TeamName }}
    </mat-checkbox>
  </div>
</div>
